<div class="avatar__container">
  <img [src]="avatarSrc" alt="Avatar" class="avatar__image" />
</div>
